export const landingVideos = {
  mp4: 'https://cdn.shopify.com/videos/c/o/v/7c546b2203a94582a97034a059e6ab73.mp4',
  mobile: {
    mp4: 'https://cdn.shopify.com/videos/c/o/v/b6f7309fd0d34b218d09c0e01a982e00.mp4',
  },
};

export const LANDING_VIDEO_THUMBNAIL =
  'https://cdn.shopify.com/s/files/1/0449/1801/4109/files/drop_2026-10-04_thumbnail.png?v=1790836976';
